module.exports = __webpack_public_path__ + "static/media/03.Bhaskar Kamath with Puppet.b85e9806.jpg";